import { Controller } from "@hotwired/stimulus";
import { t, format } from "../../lib/i18n";

const CONFLICT_EVENT = "job-questions--autosave:conflict";

export default class extends Controller {
  static targets = ["banner", "message", "textarea"];

  connect() {
    this.serverPayload = null;
    this.localText = null;
    this.boundHandleConflict = this.handleConflict.bind(this);
    this.element.addEventListener(CONFLICT_EVENT, this.boundHandleConflict);
  }

  disconnect() {
    this.element.removeEventListener(CONFLICT_EVENT, this.boundHandleConflict);
  }

  handleConflict(event) {
    this.serverPayload = event.detail;
    this.localText = this.textareaTarget.value;

    const text = this.serverPayload && this.serverPayload.conflict_with
      ? format(
        "views.hiring.job_questions.v2.conflict.message_with_name",
        "%{name} is also editing this draft.",
        { name: this.serverPayload.conflict_with },
      )
      : t(
        "views.hiring.job_questions.v2.conflict.message",
        "Someone else is editing this draft.",
      );

    if (this.hasMessageTarget) this.messageTarget.textContent = text;
    if (this.hasBannerTarget) this.bannerTarget.style.display = "block";
  }

  loadTheirs() {
    if (!this.serverPayload) return;
    this.autosaveController()?.applyServerVersion(this.serverPayload);
    this.dismiss();
  }

  overwriteWithMine() {
    if (!this.serverPayload) return;
    this.textareaTarget.value = this.localText;
    this.autosaveController()?.acceptServerLockKeepLocalText(this.serverPayload);
    this.dismiss();
  }

  dismiss() {
    this.serverPayload = null;
    this.localText = null;
    if (this.hasBannerTarget) this.bannerTarget.style.display = "none";
  }

  autosaveController() {
    return this.application.getControllerForElementAndIdentifier(this.element, "job-questions--autosave");
  }
}
